import "./output.css";
import "tailwindcss/tailwind.css";

import NavBar from "./components/layout/NavBar";
import Landing from "./components/layout/Landing";
import Register from "./components/Register";
import Auth from "./components/Auth";
import AuthGuest from "./components/AuthGuest";
import Widget from "./components/Widget";
import Payment from "./components/Payment";
import PaymentConfirmation from "./components/PaymentConfirmation";
import Unavailable from "./components/Unavailable";
import MagicLink from "./components/MagicLink";
import MagicLinkAuth from "./components/MagicLinkAuth";
import ShareProject from "./components/ShareProject";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import AuthGaurd from "./gaurds/AuthGaurd";
import Footer from "./components/layout/Footer";

const App = () => {
  const containerStyles = {
    position: "relative",
    top: "80px",
    padding: "2.75rem 0",
  };

  return (
    <>
      <Router>
        <NavBar />
        <div style={containerStyles}>
          <Routes>
            {/* general routes */}
            <Route exact path="/" element={<Navigate to="/guest" />} />
            <Route exact path="/login/" element={<Auth />} />
            <Route exact path="/guest/" element={<AuthGuest />} />
            <Route
              exact
              path="/:fulfillment/:code"
              element={<MagicLinkAuth />}
            />
            {/* admin routes */}
            <Route element={<AuthGaurd role="admin" />}>
              <Route exact path="/register/" element={<Register />} />
            </Route>
            {/* acount manager routes */}
            <Route element={<AuthGaurd role="am" />}>
              <Route exact path="/magic-link/" element={<MagicLink />} />
            </Route>
            {/* shared routes */}
            <Route element={<AuthGaurd role={["guest", "am"]} />}>
              <Route
                element={
                  <AuthGaurd
                    permissions={[
                      { hash: "project", permission: "P-NEW" },
                      { hash: "dashboard", permission: "P-SHS" },
                      {
                        hash: "project/posted/:project_id",
                        permission: "P-SHO",
                      },
                      {
                        hash: "project/posted/:completed_form/payment/:id_bill/success",
                        permission: "P-NEW",
                      },
                      {
                        hash: "project/posted/:project_id/revision/:id_deliverable",
                        permission: "D-REV",
                      },
                      {
                        hash: "project/posted/:project_id/winner-revision/:id_deliverable",
                        permission: "D-REV",
                      },
                      {
                        hash: "project/posted/:project_id/reject/:id_deliverable",
                        permission: "D-REJ",
                      },
                      {
                        hash: "project/posted/:project_id/history/:id_deliverable",
                        permission: "P-SHO",
                      },
                      {
                        hash: "project/posted/:project_id/approve/:id_deliverable",
                        permission: "D-APP",
                      },
                    ]}
                  />
                }
              >
                <Route exact path="/widget/" element={<Widget />} />
              </Route>
              <Route element={<AuthGaurd permissions={["P-SHA"]} />}>
                <Route
                  exact
                  path="/invite-people/:idProject"
                  element={<ShareProject />}
                />
              </Route>
              <Route exact path="/payments/:data/" element={<Payment />} />
              <Route
                exact
                path="/payments-confirmation/"
                element={<PaymentConfirmation />}
              />
            </Route>
            <Route path="*" element={<Unavailable />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </>
  );
};

export default App;
